export default __webpack_public_path__ + "static/media/Microsoft Surface Pro (2017).3cb8fc02.png";